import {OptionDialogComponent} from "./option.dialog.component";

export * from './option.dialog';
export * from './option.dialog.decorator';

export const OPTION_DIALOG_COMPONENTS = [
    OptionDialogComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/option-dialog/index.ts